import React, { useState, useEffect } from "react";
import axios from "axios";
import { getFirestore, collection, addDoc, getDocs } from "firebase/firestore";
import { getAuth, signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert2";
import { HamburgerIcon, SearchIcon } from "@chakra-ui/icons";
import { ChevronDownIcon } from "@chakra-ui/icons";
import Sidebar from "../Elements/Sidebar"; // Import Sidebar component
import "../../assets/dashboard/assetss/css/Blog.css";
import app from "../../backend/firebase.config";

const dbRef = getFirestore(app);

function BlogDashboardScreen() {
    const [isCreatePopupOpen, setIsCreatePopupOpen] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState("all");
    const [filteredPosts, setFilteredPosts] = useState([]);
    const [techNews, setTechNews] = useState([]);
    const [sportNews, setSportNews] = useState([]);
    const [news, setNews] = useState([]);
    const [blogPosts, setBlogPosts] = useState([]);
    const [category, setCategory] = useState("");
    const [topic, setTopic] = useState("");
    const [content, setContent] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [userName, setUserName] = useState("Ahmed Musa");
    const [userImage, setUserImage] = useState("https://bit.ly/dan-abramov");
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchTechNews = async () => {
            try {
                const response = await axios.get("https://gnews.io/api/v4/search?q=technology&token=5a0dfcd490bbc86829230a53825da43e");
                setTechNews(response.data.articles);
            } catch (error) {
                console.error("Error fetching tech news: ", error);
            }
        };

        const fetchSportNews = async () => {
            try {
                const response = await axios.get("https://gnews.io/api/v4/search?q=sports&token=5a0dfcd490bbc86829230a53825da43e");
                setSportNews(response.data.articles);
            } catch (error) {
                console.error("Error fetching sport news: ", error);
            }
        };

        const fetchAllNews = async () => {
            try {
                const response = await axios.get("https://gnews.io/api/v4/top-headlines?token=5a0dfcd490bbc86829230a53825da43e");
                setNews(response.data.articles);
            } catch (error) {
                console.error("Error fetching news: ", error);
            }
        };

        const fetchBlogPostsFromFirestore = async () => {
            try {
                const querySnapshot = await getDocs(collection(dbRef, "mtu-articles"));
                const blogPostsData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setBlogPosts(blogPostsData);
            } catch (error) {
                console.error("Error fetching blog posts: ", error);
            }
        };

        fetchTechNews();
        fetchSportNews();
        fetchAllNews();
        fetchBlogPostsFromFirestore();
    }, []);

    useEffect(() => {
        const auth = getAuth();
        const unsubscribe = auth.onAuthStateChanged(user => {
            if (!user) {
                navigate('/login');
            }
        });
        return unsubscribe;
    }, [navigate]);

    const toggleCreatePopup = () => {
        setIsCreatePopupOpen(!isCreatePopupOpen);
    };

    useEffect(() => {
        if (selectedFilter === "tech") {
            setFilteredPosts(techNews);
        } else if (selectedFilter === "sports") {
            setFilteredPosts(sportNews);
        } else if (selectedFilter === "news") {
            setFilteredPosts(news);
        } else if (selectedFilter === "article") {
            setFilteredPosts(blogPosts);
        } else {
            setFilteredPosts([...techNews, ...sportNews, ...news, ...blogPosts]);
        }
    }, [selectedFilter, techNews, sportNews, news, blogPosts]);

    const handleCreateBlog = async (e) => {
        e.preventDefault();
        try {
            await addDoc(collection(dbRef, "mtu-articles"), {
                category,
                topic,
                content,
                owner: getAuth().currentUser?.uid,
                completed: false
            });
            setIsCreatePopupOpen(false);
            setCategory("");
            setTopic("");
            setContent("");
        } catch (error) {
            console.error("Error adding blog post: ", error);
        }
    };

    const handleSignOut = () => {
        swal.fire({
            title: "Are you sure you want to log out?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Logout",
        }).then((result) => {
            if (result.isConfirmed) {
                const auth = getAuth();
                signOut(auth).then(() => {
                    navigate('/login');
                }).catch((error) => {
                    console.error("Error signing out: ", error);
                });
            }
        });
    };

    const handlePrevVideo = () => {
        setCurrentVideoIndex((prevIndex) => (prevIndex === 0 ? 2 : prevIndex - 1));
    };

    const handleNextVideo = () => {
        setCurrentVideoIndex((prevIndex) => (prevIndex === 2 ? 0 : prevIndex + 1));
    };

    return (
        <div>
            <header className="header">
                <div className="nav container">
                    <button style={{ color: "green", borderWidth: 0, background: "transparent" }} className="logo">
                        Nasels <span style={{ color: "green" }}> Blog </span>
                    </button>
                    <div className="header-center">
                        <img src={userImage} alt="User" className="user-img" />
                        <div className="dropdown-container">
                            <span className="user-name">{userName}</span>
                            <ChevronDownIcon className="down-arrow" />
                            <div className="dropdown-content">
                                <a href="#profile">Profile</a>
                                <a href="#settings">Settings</a>
                                <a href="#logout" onClick={handleSignOut}>Logout</a>
                            </div>
                        </div>
                    </div>
                    <div className="header-right">
                        <div className="search-container">
                            <input
                                type="text"
                                placeholder="Search for anything?"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className="search-input"
                            />
                            <SearchIcon className="search-icon" />
                        </div>
                        <HamburgerIcon className="menu-icon" onClick={() => setIsSidebarOpen(true)} />
                    </div>
                </div>
            </header>

            <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

            {/* First section */}
            <section className="about make" id="about">
                <div style={{ marginTop: "10%" }} className="contentBx"> 
                    <h2 className="titleText">Catch up with the trending topics in our Blog</h2>
                    <p className="title-text">
                        Welcome to the official website of the National Association of Students of English and Literary Studies in Mountain Top University, Ogun State, Nigeria. NASELS MTU is one of the many chapters of NASELS instituted in Nigeria, catering to the students of the Department of English at MTU.
                    </p>
                    <button style={{ color: "green" }} className="btn2" onClick={toggleCreatePopup}>Create</button>
                </div>
                <div className="video-carousel-container" style={{ width: "100%", overflow: "hidden", position: "relative" }}>
                    <div className="video-carousel" style={{ display: "flex", transition: "transform 0.5s ease-in-out", transform: `translateX(-${currentVideoIndex * 100}%)` }}>
                        <iframe 
                            src="https://www.youtube.com/embed/video1" 
                            title="Video 1" 
                            style={{ flex: "0 0 100%", border: "none", height: "300px" }}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                            allowFullScreen
                        ></iframe>
                        <iframe 
                            src="https://www.youtube.com/embed/video2" 
                            title="Video 2" 
                            style={{ flex: "0 0 100%", border: "none", height: "300px" }}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                            allowFullScreen
                        ></iframe>
                        <iframe 
                            src="https://www.youtube.com/embed/video3" 
                            title="Video 3" 
                            style={{ flex: "0 0 100%", border: "none", height: "300px" }}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                            allowFullScreen
                        ></iframe>
                    </div>
                    <button onClick={handlePrevVideo} style={{ position: "absolute", top: "50%", left: "10px", transform: "translateY(-50%)" }}>Prev</button>
                    <button onClick={handleNextVideo} style={{ position: "absolute", top: "50%", right: "10px", transform: "translateY(-50%)" }}>Next</button>
                </div>
            </section>

            {/* Navigation */}
            <div className="navigation" style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "20px"
            }}>
                <button style={{ margin: "0 10px" }} onClick={() => setSelectedFilter("all")}>All</button>
                <button style={{ margin: "0 10px" }} onClick={() => setSelectedFilter("tech")}>Technology</button>
                <button style={{ margin: "0 10px" }} onClick={() => setSelectedFilter("sports")}>Sports</button>
                <button style={{ margin: "0 10px" }} onClick={() => setSelectedFilter("news")}>News</button>
                <button style={{ margin: "0 10px" }} onClick={() => setSelectedFilter("article")}>Articles</button>
            </div>

            {/* Posts display */}
            <section className="posts">
                <div className="posts-container">
                    {filteredPosts.map(post => (
                        <div key={post.id} className="post-card" style={{ margin: "10px", padding: "10px", border: "1px solid #ddd", borderRadius: "5px" }}>
                            <img src={post.image} alt={post.title} style={{ width: "100%", height: "auto", borderRadius: "5px" }} />
                            <h3 style={{ fontSize: "1.2rem", marginTop: "10px" }}>{post.title}</h3>
                            <p>{post.description}</p>
                            <button style={{ backgroundColor: "green", color: "#fff", border: "none", padding: "10px", borderRadius: "5px" }}>Learn More</button>
                        </div>
                    ))}
                </div>
            </section>

            {/* Popup for creating blog post */}
            {isCreatePopupOpen && (
                <div className="popup" style={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "80%",
                    maxWidth: "600px",
                    backgroundColor: "#fff",
                    padding: "20px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                    borderRadius: "10px"
                }}>
                    <h2>Create a New Blog Post</h2>
                    <form onSubmit={handleCreateBlog}>
                        <label>
                            Category:
                            <input 
                                type="text" 
                                value={category} 
                                onChange={(e) => setCategory(e.target.value)} 
                                style={{ display: "block", width: "100%", marginBottom: "10px" }} 
                            />
                        </label>
                        <label>
                            Topic:
                            <input 
                                type="text" 
                                value={topic} 
                                onChange={(e) => setTopic(e.target.value)} 
                                style={{ display: "block", width: "100%", marginBottom: "10px" }} 
                            />
                        </label>
                        <label>
                            Content:
                            <textarea 
                                value={content} 
                                onChange={(e) => setContent(e.target.value)} 
                                style={{ display: "block", width: "100%", height: "100px", marginBottom: "10px" }} 
                            />
                        </label>
                        <button type="submit" style={{ backgroundColor: "green", color: "#fff", border: "none", padding: "10px", borderRadius: "5px" }}>Submit</button>
                        <button type="button" onClick={toggleCreatePopup} style={{ marginLeft: "10px", backgroundColor: "#f44336", color: "#fff", border: "none", padding: "10px", borderRadius: "5px" }}>Cancel</button>
                    </form>
                </div>
            )}
        </div>
    );
}

export default BlogDashboardScreen;
    